// Font Awesome + app-ui.css are for login/signup and the logged-in app.
// Marketing routes skip them so the first paint does not download that CSS.
import { useEffect } from "react";

const MARKETING =
  /^\/($|aboutus\/?$|how-it-works|programs\/?$|saas\/?$|mentors\/?$|faq\/?$|contact-us\/?$|event\/|resource-hub|newsletter\/?$|videos\/?$|event-detail\/|resources-details\/)/;

let loading;

export function isMarketingPath(pathname) {
  return MARKETING.test(pathname || "/");
}

export function loadAppChromeCss() {
  if (loading) return loading;
  loading = Promise.all([
    import("@fortawesome/fontawesome-free/css/all.css"),
    import("../styles/app-ui.css"),
  ]);
  return loading;
}

export function useAppChromeCss(needed) {
  useEffect(() => {
    if (needed) loadAppChromeCss();
  }, [needed]);
}
